module.exports = __webpack_public_path__ + "static/media/dashboard.f283e7cf.png";